import { FooterListItemProps } from "./FooterListItem/props";
import { openCookiePreferences } from "../../../util/cookieConsent";

export const productsItems: FooterListItemProps[] = [
  {
    text: "Innovance Agenda",
    href: "/agenda/",
  },
  {
    text: "Innovance Absences",
    href: "/absences/",
  },
  {
    text: "Innovance Budget",
    href: "/budget/",
  },
  {
    text: "Innovance Métronome",
    href: "/metronome/",
  },
];

export const servicesItems: FooterListItemProps[] = [
  {
    text: "La formation",
  },
  {
    text: "L'accompagnement",
  },
  {
    text: "L'assistance téléphonique",
  },
  {
    text: "La maintenance évolutive",
  },
];

export const aboutItems: FooterListItemProps[] = [
  {
    href: "/contact/",
    text: "Contact",
  },
  {
    href: "/clients/",
    text: "Nos clients",
  },
  {
    text: "Le blog Innovance",
    href: "https://blog.innovance-solutions.com/",
    target: "_blank",
  },
  {
    href: "/mentions-legales/",
    text: "Mentions légales",
  },
  {
    href: "/politique-confidentialite/",
    text: "Politique de confidentialité",
  },
  {
    text: "Gérer mes cookies",
    onClick: openCookiePreferences,
  },
];
